import { convertTimestampToBrazilianReadableText } from '@repo/ui';
import personIcon from 'presentation/app/assets/images/icon-person.jpeg';
import { TableColumn } from 'react-data-table-component';

interface IColumns {
  id: string;
  studentName: string;
  studentPhoto: string;
  groupName: string;
  criteriaName: string;
  surveyDate: string;
  grade: number;
}

export const makeColumnsPersonCompletedEvaluations =
  (): TableColumn<IColumns>[] => {
    return [
      {
        name: 'Estudante',
        selector: (row) => row.studentName,
        wrap: true,
        width: '15%',
        sortable: false,
        cell: (row) => (
          <div className="d-flex align-items-center gap-3 py-2">
            <img
              src={row?.studentPhoto || personIcon}
              alt="Foto do Estudante"
              className="avatar object-fit-cover"
            />
            <div className="d-flex flex-column">
              <span>
                <strong>{row?.studentName}</strong>
              </span>
            </div>
          </div>
        ),
      },
      {
        name: 'Grupo',
        selector: (row) => row.groupName,
        sortable: false,
        wrap: true,
      },
      {
        name: 'Instrumento',
        selector: (row) => row.criteriaName || '-',
        sortable: false,
        wrap: true,
      },
      {
        name: 'Data',
        selector: (row) =>
          convertTimestampToBrazilianReadableText(row.surveyDate),
        sortable: false,
        wrap: true,
      },
      {
        name: 'Nota',
        selector: (row) => row.grade,
        sortable: false,
      },
    ];
  };
